import styled from "styled-components";

const Message = styled.div`
`;

export default function ProductListEmpty(){
    return (
        <Message>Product list is empty. It's may be a error!</Message>
    )
}